<template lang="pug">
	
	.flags-overlay
		flag(v-for="(flag,i) in flags" :x="flag.x" :y="flag.y" :key="flag.id" ref="flag")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import Section from '../abstracts/section'
	import FlagsData from './flags-data.json'
	import Flag from './flag.vue'
	import Scrollable from '../abstracts/scrollable'
	import Globals from '~utils/Globals.js'

	
  @Component({
		name: 'FlagsOverlay',
		components: { Flag },
		props: [],
		data : function () {
			return {
				flags : FlagsData.flags
			}
		}
	})

	class FlagsOverlay extends Scrollable {

		mounted () {
			super.mounted()

			this.$events.on('app.loaded', this.init)
		}
				
		init () {
			super.init()
		}

		initTimeline () {
			super.initTimeline()

			for(let i = 0; i < this.$refs.flag.length; i++) {
				const f = this.$refs.flag[i].$el
				const r = (Math.random() * (300 - 50)) + 50
				this.tl.fromTo(f,1,{y:r},{y:0},0)
			}
		}

		raf (y) {
			super.raf(y)	
		}

		_bind () {
			super._bind()
		}


		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top
			}

			for(let i = 0; i < this.$refs.flag.length; i++) {
				const f = this.$refs.flag[i]
				
				f.resize()
			}

		}

		update (pos) {
			for(let i = 0; i < this.$refs.flag.length; i++) {
				const f = this.$refs.flag[i]
				
				f.update(pos)
			}
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

	}

	export default FlagsOverlay

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.flags-overlay
		
		width 100vw
		height 100vh
		
		

</style>


// WEBPACK FOOTER //
// flags-overlay.vue?897e34d6